import { render } from "./shortcuts.vue?vue&type=template&id=b9895d60&scoped=true"
import script from "./shortcuts.vue?vue&type=script&lang=js"
export * from "./shortcuts.vue?vue&type=script&lang=js"

import "./shortcuts.vue?vue&type=style&index=0&id=b9895d60&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9895d60"]])

export default __exports__